import { useEffect } from "react";
import {
  Flex, Box, IconButton, useDisclosure, Button, Link,
  Menu, MenuButton, MenuList, MenuItem, Portal,
} from "@chakra-ui/react";
import { HamburgerIcon, CloseIcon } from "@chakra-ui/icons";
import { logout } from "../../redux/reducers/authReducer";
import { useDispatch } from "react-redux";
import { Link as RouterLink, useLocation, useNavigate } from "react-router-dom";
import { FaChevronDown, FaAngleDoubleLeft, FaAngleDoubleRight } from "react-icons/fa";
import { useShowSidebar } from "../../modules/context/showSidebarContext";
import toast from "react-hot-toast";

const payrollLinks = [["User", "/userCreate"], ["Role", "/roleCreate"]];
const tableLinks = [["Table Status", "/table-status"]];
const foodBillLinks = [
  ["Kot Bill", "/kotBill"],
  ["Quick Bill", "/quickBill"],
  ["Daily Sales Summary", "/dailySales"],
  ["Complementary Sales Summary", "/complementarySales"],
  ["Void Bill", "/voidBill"],
  ["Waiter Bill", "/waiterBill"],
];
const inventoryLinks = [
  ["Supply Register", "/supply-register"],
  ["Item Register", "/item-register"],
  ["Store Register", "/store-register"],
  ["Staff Register", "/staff-register"],
  ["Purchase Register", "/purchase-register"],
  ["Store", "/store"],
  ["Stock Transfer", "/stock-transfer"],
  ["Purchase Report", "/purchase-report"],
  ["Transfer Report", "/stock-transfer-report"],
  ["Transfer Summary", "/stock-transfer-summary"],
];

const NavigationMenu = ({ label, links, onNavigate }) => (
  <Menu>
    <MenuButton as={Button} size="sm" minHeight="40px" bg="white" rightIcon={<FaChevronDown />} _hover={{ color: "tomato" }}>
      {label}
    </MenuButton>
    <Portal>
      <MenuList maxWidth="calc(100vw - 24px)" maxHeight="70vh" overflowY="auto" zIndex="popover">
        {links.map(([text, path]) => (
          <MenuItem key={path} as={RouterLink} to={path} onClick={onNavigate} minHeight="44px" py={3} whiteSpace="normal" fontSize="sm" lineHeight="1.4">
            {text}
          </MenuItem>
        ))}
      </MenuList>
    </Portal>
  </Menu>
);

const Navbar = () => {
  const { showSidebar, handleShowSidebar } = useShowSidebar();
  const { isOpen, onToggle, onClose } = useDisclosure();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const customerId = localStorage.getItem("customerId");

  useEffect(() => { onClose(); }, [location.pathname, onClose]);

  const handleLogout = () => {
    dispatch(logout());
    toast.success("Logout Successfully");
    navigate("/");
    window.location.reload();
  };

  const navigationLink = (label, path) => (
    <Link
      as={RouterLink}
      to={path}
      onClick={onClose}
      aria-current={location.pathname === path ? "page" : undefined}
      color="white"
      fontWeight="semibold"
      fontSize="sm"
      display="inline-flex"
      alignItems="center"
      minHeight="40px"
      px={2}
      py={2}
      borderBottom={location.pathname === path ? "1px solid white" : "1px solid transparent"}
      _hover={{ color: "white", textDecoration: "underline" }}
    >{label}</Link>
  );

  return (
    <Flex
      as="header"
      align="center"
      justify="space-between"
      flexWrap="wrap"
      gap={3}
      minHeight="64px"
      background="tomato"
      px={{ base: 3, md: 5 }}
      py={3}
      borderBottom="1px"
      borderColor="gray.200"
    >
      {customerId && (
        <IconButton
          onClick={handleShowSidebar}
          icon={showSidebar ? <FaAngleDoubleLeft /> : <FaAngleDoubleRight />}
          aria-label={showSidebar ? "Close sidebar" : "Open sidebar"}
          aria-expanded={showSidebar}
          aria-controls="restaurant-sidebar"
          flexShrink={0}
          minWidth="44px"
          minHeight="44px"
        />
      )}
      <IconButton
        display={{ base: "inline-flex", xl: "none" }}
        marginLeft="auto"
        onClick={onToggle}
        icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
        variant="ghost"
        aria-label={isOpen ? "Close navigation" : "Open navigation"}
        aria-expanded={isOpen}
        aria-controls="primary-navigation"
        minWidth="44px"
        minHeight="44px"
      />
      <Box
        as="nav"
        id="primary-navigation"
        aria-label="Primary navigation"
        display={{ base: isOpen ? "block" : "none", xl: "block" }}
        width={{ base: "full", xl: "auto" }}
        minWidth={0}
        marginLeft={{ xl: "auto" }}
      >
        <Flex gap={2} align="center" flexWrap="wrap">
          {customerId ? (
            <>
              <NavigationMenu label="PayRole" links={payrollLinks} onNavigate={onClose} />
              {navigationLink("Table Book", "/getRoomBook")}
              <NavigationMenu label="Table" links={tableLinks} onNavigate={onClose} />
              {navigationLink("Food", "/food")}
              {navigationLink("Wine", "/wineData")}
              <NavigationMenu label="Food Bill" links={foodBillLinks} onNavigate={onClose} />
              <NavigationMenu label="Inventory" links={inventoryLinks} onNavigate={onClose} />
              <Button size="sm" minHeight="40px" onClick={handleLogout} bg="white" _hover={{ color: "tomato" }}>Logout</Button>
            </>
          ) : (
            <>
              <Button as={RouterLink} to="/login" onClick={onClose} size="sm" minHeight="40px" bg="white">Login</Button>
              <Button as={RouterLink} to="/signup" onClick={onClose} size="sm" minHeight="40px" bg="white">Signup</Button>
            </>
          )}
        </Flex>
      </Box>
    </Flex>
  );
};

export default Navbar;
